export default "__VITE_ASSET__DBqAK_lg__"